export const ActivationErrorModalComponent = {
    template: require('./activation-error-modal.html'),
    controller: class ActivationErrorModalComponent {
        private config: any;

        private resolve: any;
        private close: any;

        $onInit(): void {
            this.config = this.resolve.config;
        }

        do(btnId: number) {
            this.close({ $value: btnId });
        }
    },
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/login/activation-error-modal/activation-error-modal.component.ts